import { render, staticRenderFns } from "./message-history.vue?vue&type=template&id=05d7121f&scoped=true"
import script from "./message-history.vue?vue&type=script&lang=js"
export * from "./message-history.vue?vue&type=script&lang=js"
import style0 from "./message-history.vue?vue&type=style&index=0&id=05d7121f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7121f",
  null
  
)

export default component.exports